import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStrip } from '../../plot/hooks/useStrip';
import { EpisodeMeasurementInfo } from './EpisodeMeasurementInfo';
import { RulerLine } from '../../ruler/components/RulerLine';
import { RulerSquare } from '../../ruler/components/RulerSquare';
import * as episodeMeasurementActions from '../actions/episode-measurement.actions';
import {
  episodeMeasurementRangeSelector,
  getEpisodeMeasurementCursor,
} from '../selectors/episode-measurement.selectors';
import { MINIMUM_RULER_DURATION } from '../../ruler/utils/ruler.utils';

export const EpisodeMeasurement: React.FC = () => {
  const dispatch = useDispatch();
  const { xScale, height } = useStrip();
  const cursor = useSelector(getEpisodeMeasurementCursor);
  const [start, end] = useSelector(episodeMeasurementRangeSelector);
  const limits = end - start > MINIMUM_RULER_DURATION ? [start, end] : [];

  return (
    <>
      {limits.map((timestamp) => (
        <RulerLine
          key={timestamp}
          timestamp={xScale(timestamp)}
          height={height}
        />
      ))}
      {
        <RulerSquare
          onset={start}
          offset={end}
          setBoundary={(boundary) =>
            dispatch(episodeMeasurementActions.setBoundary({ boundary }))
          }
          setMoving={(timestamp) =>
            dispatch(episodeMeasurementActions.setMoving({ timestamp }))
          }
          cursor={cursor}
        />
      }
      <EpisodeMeasurementInfo />
    </>
  );
};
